export default __webpack_public_path__ + "static/media/Gesture_white_Push-21.753dbb55.svg";